<template>
    <v-btn @click="click" :elevation="elevation || 10" v-bind="$attrs" style="z-index:100;height:auto;border-radius: 10px !important;" color="primary" :class="{'pa-1 mx-auto rounded-xl': true}">
                <v-card flat color="transparent" dark style="border:2px solid white!important;border-radius: 8px !important;" class="px-4 py-2 pt-3 rounded-lg"
                :class="{'py-2': !city}">
               <slot>
                 <div class="d-flex justify-center"><v-icon v-text="prependIcon" v-if="prependIcon" class="mr-1"></v-icon>
                  <div class="eetplein-header" v-text="street">mijn eetplein</div>
                  </div>
                  <div class="text-right">
                <v-chip v-if="city" color="transparent" class="white--text px-0 pt-1  eetplein-subheader" style="height:auto;" v-text="city">
                      
                    </v-chip>
                    <v-icon v-text="appendIcon" v-if="appendIcon"></v-icon>
                    </div></slot>
                </v-card>
                </v-btn> 
</template>
<script>

export default {
  props: ['street','city','elevation','prependIcon','appendIcon'],
   data: () => ({
    
  }),
  computed: {
    
  },
  methods: {
    click(){
        this.$emit('click')
    }
  }
}
</script>